import { get } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from './launchdarklyApiDef';

type ParamsTypes = {
  user: string;
  flag: string;
};

const API_KEY = 'api-32876fc1-64d2-44cb-902e-349ac87eeb43';
const PROJECT = 'canais-clientes-web-';
const ENVIRONMENT = 'production';

const call = async (pathParameters: ParamsTypes): Promise<IFinalResponse> => {
  const result: IFinalResponse = {
    success: false,
    data: null,
    errors: undefined,
    metadata: null,
  };

  try {
    const init: InitApiType = {
      pathParameters: {
        ...pathParameters,
        project: PROJECT,
        environment: ENVIRONMENT,
      },
      headers: {
        Authorization: API_KEY,
      },
    };
    const response = await get(
      Definitions.API_DOMAIN,
      Definitions.ENDPOINT_API_PATH,
      Definitions.API_CREDENTIALS_TYPE,
      init,
    );
    result.success = true;
    result.data = response.response._value;
  } catch (error) {
    result.success = false;
    result.data = null;
    result.errors = [error];
  }

  return result;
};

export default { call, definitions: Definitions };
